import React, { useState } from "react";
import ConnectYourBusiness from "./components/ConnectYourBusiness";
import ConfigureYourAIWeb from "./components/ConfigureYourAIWeb";
import ConfigureYourAIUpload from "./components/ConfigureYourAIUpload";
import ConfigureYourAIDetail from "./components/ConfigureYourAIDetail";
import AuthTopBar from "../authentication/component/AuthTopBar";
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "../../context/user";
import { useCustomFields } from "../../queries/auth";

const Onboarding = () => {
  const [businessType, setBusinessType] = useState(null);
  const [success, setSuccess] = useState(false);
  const logout = useUserInfo()[2];
  const userInfo = useUserInfo()[0];
  const navigate = useNavigate();
  const { mutate: customFields } = useCustomFields();


  const HandleEveryStep = (step) => {

    if (step === 5) {
      customFields({
        userId: userInfo.userId,
        step: step,
      });
    } else {
      return;
    }
  }

  return (
    <div className="bg-background h-screen text-foreground">
      <AuthTopBar />
      <div className="relative h-[calc(80%-61px)] flex flex-col justify-center items-center ">
        {/* {businessType === "url" && !success && <p className="text-[#757575] absolute top-7 right-12">
          Already have an account?{" "}
          <button
            className="text-[#1E1E1E]"
            onClick={() => {
              logout();
              navigate("/auth/sign-in");
            }}
          >
            Sign in
          </button>
        </p>} */}
        <>
          {businessType === "url" && (
            <ConfigureYourAIWeb
              setBusinessType={setBusinessType}
              setSuccess={setSuccess}
              HandleEveryStep={HandleEveryStep}
            />
          )}

          {businessType === "file" && (
            <ConfigureYourAIUpload
              setBusinessType={setBusinessType}
              setSuccess={setSuccess}
              HandleEveryStep={HandleEveryStep}
            />
          )}

          {businessType === "detail" && (
            <ConfigureYourAIDetail
              setBusinessType={setBusinessType}
              setSuccess={setSuccess}
              HandleEveryStep={HandleEveryStep}
            />
          )}

          {!businessType && (
            <ConnectYourBusiness setBusinessType={setBusinessType} />
          )}

        </>
        {/* <div className="flex justify-start start">
          <span onClick={() => businessType ? setBusinessType(null) : navigate(-1)} className='text-muted-foreground text-[12px] mt-8 cursor-pointer'>
            ← Go back
          </span>
        </div> */}
      </div>


    </div>
  );
};

export default Onboarding;
